import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { CommunicatorMessageType, MessageTypeToTemplateMapping, Template } from '@quorum/models/xs-resource';
import { RouterStateService } from '@quorum/sha-router';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { TemplatesFacade } from '@quorum/xsr-template-library';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
@Component({
  selector: 'quorum-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.

      transition('* => *', [
        query(':enter', [style({ opacity: 0 }), stagger(60, [style({ opacity: 1 }), animate('200ms')])], {
          optional: true,
        }),
      ]),
    ]),
  ],
})
export class GalleryComponent implements OnInit, OnDestroy {
  custId: string;
  templates: Template[];
  filteredMessageTypes$: Observable<CommunicatorMessageType[]>;
  filteredTemplates:
    | Template[]
    | {
        messageType: {
          templates: Template[];
          messageTypeDescription: string;
          defaultTemplateRequired: boolean;
          defaultTemplateId: string;
        };
      };

  filterForm: FormGroup = new FormGroup({
    messageType: new FormControl(),
  });
  routerStateMessageType$: Subscription;

  loading = false;
  constructor(
    private authenticationStateService: AuthenticationStateService,
    private systemControlStateService: SystemControlStateService,
    private routerStateService: RouterStateService,
    public templateFacade: TemplatesFacade
  ) {}

  ngOnInit(): void {
    this.authenticationStateService
      .selectAuthenticatedEmployee()
      .pipe(
        filter((employee) => employee != null),
        map((employee) => employee.rooftopId)
      )
      .subscribe((employeeRooftopId) => {
        this.systemControlStateService
          .getSystemControlValue('CL_BODY_SHOP_DEALER', employeeRooftopId)
          .pipe(
            take(1),
            map((sctValue) => (sctValue == '' || null ? false : true))
          )
          .subscribe((bodyShopDealer) => {
            this.filteredMessageTypes$ = this.templateFacade.messageTypes$.pipe(
              map((messageTypes) =>
                bodyShopDealer
                  ? messageTypes
                  : messageTypes.filter((messageType) => messageType.description.includes(`(Body Shop)`))
              )
            );
          });
      });

    this.authenticationStateService
      .selectAuthenticatedUser()
      .pipe(
        take(1),
        map((authUser) => authUser.user.destination)
      )
      .subscribe((custId) => (this.custId = custId));

    this.routerStateMessageType$ = this.routerStateService
      .selectRouterState()
      .pipe(
        map((routerState) => {
          return routerState.state.root.queryParams?.messageType
            ? parseInt(routerState.state.root.queryParams.messageType)
            : 999;
        }),
        tap((messageType) => {
          this.loading = true;
          this.filterForm.get('messageType').patchValue(messageType, { emitEvent: false });
        }),
        switchMap((messageType) =>
          combineLatest([
            this.templateFacade.storeGalleryByMessageTypeWithDefaults$,
            this.templateFacade.storeGallery$,
            of(messageType),
          ]).pipe(
            filter(
              ([mappedTemplates, storeGalleryTemplates]) =>
                Object.keys(mappedTemplates).length > 0 && storeGalleryTemplates.length > 0
            ),
            take(1)
          )
        )
      )
      .subscribe(([mappedTemplates, storeGalleryTemplates, messageType]) => {
        this.loading = false;
        this.filteredTemplates =
          messageType === 999 ? storeGalleryTemplates : { messageType: mappedTemplates[messageType] };
      });
  }

  ngOnDestroy(): void {
    this.routerStateMessageType$.unsubscribe();
  }
  setDefault(messageType: string, template: Template) {
    this.templateFacade.messageTypeToTemplateMappings$.pipe(take(1)).subscribe((mappings) => {
      let messageTypeTemplateMapping = mappings.find((mapping) => mapping.messageTypeId === parseInt(messageType));

      if (messageTypeTemplateMapping) {
        messageTypeTemplateMapping.templateId = template.id;
        this.templateFacade.patchMessageTypeToTemplateMapping(messageTypeTemplateMapping);
      } else {
        messageTypeTemplateMapping = new MessageTypeToTemplateMapping({
          custId: this.custId,
          messageTypeId: parseInt(messageType),
          templateId: template.id,
        });
        this.templateFacade.createMessageTypeToTemplateMapping(messageTypeTemplateMapping);
      }
    });
  }

  trackMessageTypeRepeater(key: number) {
    return key;
  }
  // loadImage(imagePath: string) {
  //   return new Observable(function (observer: any) {
  //     var img = new Image();
  //     img.src = imagePath;
  //     img.onload = function () {
  //       observer.next(img);
  //       observer.complete();
  //     };
  //     img.onerror = function (err) {
  //       observer.onError(err);
  //     };
  //   });
  // }
}
